// extracted by mini-css-extract-plugin
export default {"registrationButtonSpacing":"I9d-6","registrationButtonSpacing--noImage":"_5NK9n","registrationButtonSpacingNoImage":"_5NK9n"};